import {z} from "zod";

const ageAtLeast18 = (isoDate: string): boolean => {
  const birth = new Date(isoDate);
  if (Number.isNaN(birth.getTime())) return false;
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age >= 18;
};

export const registrationSchema = z
  .object({
    email: z.string().trim().min(1, "El correo es obligatorio").email("Correo inválido"),
    password: z
      .string()
      .min(8, "La contraseña debe tener al menos 8 caracteres")
      .regex(/[A-Z]/, "Debe incluir al menos una mayúscula")
      .regex(/[0-9]/, "Debe incluir al menos un número"),
    confirmPassword: z.string().min(1, "Confirma tu contraseña"),
    birthDate: z
      .string()
      .min(1, "Selecciona tu fecha de nacimiento")
      .refine(ageAtLeast18, "Debes ser mayor de 18 años"),
    preferredBonus: z.enum(["slot", "sport", "casino"]).default("slot"),
    agreeToTerms: z.boolean().refine(value => value === true, "Debes aceptar los términos"),
  })
  .refine(data => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "Las contraseñas no coinciden",
  });

export type RegistrationFormValues = z.infer<typeof registrationSchema>;
